<template>
  <div class="mutexDrugs">
    <el-button icon="el-icon-refresh" @click="$refresh(getMutexList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="药品名称">
            <el-input v-model.trim="searchForm.drugNameOne" placeholder="请输入需查询药品名称"/>
          </el-form-item>
          <el-form-item label="互斥类型">
            <el-select v-model="searchForm.type" placeholder="请选择药品互斥类型">
              <el-option v-for="item in [{value: '0', label: '十八反'}, {value: '1', label: '十九畏'}]" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getMutexList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getMutexList, { drugNameOne: null, type: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addMutex">新增规则</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteMutexList">批量删除</el-button>
      </div>
      <!-- 药品列表 -->
      <el-table v-loading="loading" :max-height="tableHeight" :data="effectsList" ref="multipleTable" @selection-change="val => $handleSelectionChange(val, true)" border>
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="drugNameOne" label="药品名称1"/>
        <el-table-column prop="drugNameTwo" label="药品名称2"/>
        <el-table-column prop="type" label="类型"/>
        <el-table-column prop="updateBy" label="操作员"/>
        <el-table-column prop="updateTime" label="更新时间" min-width="150"/>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" type="danger" @click="deleteMutex(scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" title="新增十八反十九畏" :visible.sync="dialogVisible" width="370px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="90px">
          <el-form-item label="药品名称1" prop="drugNameOne">
            <el-input v-model.trim="editForm.drugNameOne" clearable placeholder="请输入药品名称1"/>
          </el-form-item>
          <el-form-item label="药品名称2" prop="drugNameTwo">
            <el-input v-model.trim="editForm.drugNameTwo" clearable placeholder="请输入药品名称2"/>
          </el-form-item>
          <el-form-item label="互斥类型" prop="type">
            <el-radio-group v-model="editForm.type">
              <el-radio v-for="item in [{value: '0', label: '十八反'}, {value: '1', label: '十九畏'}]" :key="item.value" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
          <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getMutexList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { effectsList, effectsAdd, effectsDelete } from "@/api/mutexdrugs"; // 药品请求
export default {
  data() {
    return {
      loading: true, // 加载中
      searchForm: { drugNameOne: null, type: null }, // 查询表单
      editForm: {}, // 新增表单
      effectsList: [], // 药品列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogVisible: false,
      editFormRules: {
        drugNameOne: [{required: true, message: "药品名称1不能为空！", trigger: "change"}, { pattern: /\S\S/, message: '药品名称1文字数量必须大于等于两个文字', trigger: 'change'}],
        drugNameTwo: [{required: true, message: "药品名称2不能为空！", trigger: "change"}, { pattern: /\S\S/, message: '药品名称2文字数量必须大于等于两个文字', trigger: 'change'}]
      }, // 验证规则
      multipleSelection: [],
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getMutexList(); // 页面初始化获取药品列表
  },
  methods: {
    // 请求所有药品列表
    async getMutexList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await effectsList(params);
      
      if (code == 200) {
        this.total = total;
        rows.forEach(item => { item.type == '0' ? item.type = "十八反" : item.type = "十九畏" });
        this.effectsList = rows;
      }
      this.loading = false;
    },
    // 删除互斥
    deleteMutex(row) {
      this.$confirm('确认删除该互斥药品？').then(_ => { this.del(row.sideEffectsId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await effectsDelete(id);
      if (code == 200) this.$message.success("删除互斥药品成功！");
      this.$refresh(this.getMutexList);
    },
    // 批量删除标签互斥
    deleteMutexList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何互斥药品！");
      else {
        selected.forEach(item => { selectedId.push(item.sideEffectsId) });
        this.$confirm('确认删除该互斥药品？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    },
    // 新增互斥
    addMutex() {
      this.dialogVisible = true;
      this.editForm = { drugNameOne: null, drugNameTwo: null, type: "0"};
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          effectsAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增互斥药品成功！");

            this.dialogVisible = false;
            this.$refresh(this.getMutexList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>

<style lang="less" scoped>
  .mutexDrugs {
    box-sizing: border-box;
    padding: 20px;
  }
</style>